export const getChildAge = (birthDay: string | Date) => {
  const ageDifference = Date.now() - new Date(birthDay).getTime()
  const ageDate = new Date(ageDifference)

  return Math.abs(ageDate.getUTCFullYear() - 1970)
}
